/**
 * openSelectSections
 * @param recordID
 * @param kontrolleID
 * @param counter
 */
window.openSelectSections = function(recordID, kontrolleID, counter) {
  let newDate = new Date(document.getElementById('feldkontrolle-date-' + recordID + '-' + counter).value);
  const newDateUnix = newDate.getTime() / 1000;
  ajaxDialog(BASE_PATH + 'ajax/dialog/vegetationErnte/ajax.addSectionFeldkontrolle.php', 1000, {
    post_data: {
      recordID,
      kontrolleID,
      counter,
      date: newDateUnix,
      selectedSections: document.getElementById('feldkontrolle-sections-' + recordID + '-' + kontrolleID).value,
    },
  });
};

/**
 * updateSectionsByLockdate
 * @param recordID
 * @param kontrolleID
 * @param counter
 */
window.updateSectionsByLockdate = function(recordID, kontrolleID, counter) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/vegetationErnte/ajax.updateSectionsByLockdate',
    type: 'post',
    dataType: 'json',
    data: {
      recordID,
      newDate: document.getElementById('feldkontrolle-date-' + recordID + '-' + counter).value,
    },
    success: function(response) {
      if (response['success'] === true) {
        document.getElementById('feldkontrolle-sortenNamen-' + recordID + '-' + kontrolleID).innerHTML = response['sortenNamen'];
        document.getElementById('feldkontrolle-anlageName-' + recordID + '-' + kontrolleID).innerHTML = response['anlagenNamen'];
        document.getElementById('feldkontrolle-anlageNameTooltip-' + recordID + '-' + kontrolleID).dataset.title = response['anlagenNamen'];
        document.getElementById('feldkontrolle-sortenNameTooltip-' + recordID + '-' + kontrolleID).dataset.title = response['sortenNamen'];
        if (response['sortenNamen'].length === 0) {
          const checkbox = document.getElementById('feldkontrolle-' + recordID + '-' + counter);
          checkbox.disabled = true;
          checkbox.checked = false;
        } else {
          document.getElementById('feldkontrolle-' + recordID + '-' + counter).disabled = false;
        }
        destroyTooltips();
        initTooltip();
      }
    },
  });
};